import type { IResponseBase } from '@/interfaces';
import { Http } from './http';
import type { IIndex } from '@/interfaces/IIndex';

const http = Http.create();

export class IndexService {
    static async getIgpm(month: number, year: number) {
        const response = await http.get<IResponseBase<IIndex>>(
            `/index/igpm/`,
            { params: { month, year } }
        );
        return response.data;
    }

    static async getIpca(month: number, year: number) {
        const response = await http.get<IResponseBase<IIndex>>(
            `/index/ipca/`,
            { params: { month, year } }
        );
        return response.data;
    }
}